import { render } from "./SubmitQuotation.vue?vue&type=template&id=490feb63"
import script from "./SubmitQuotation.vue?vue&type=script&lang=js"
export * from "./SubmitQuotation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__